import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';
import { AgentFlowProgress } from './model';

export const AGENT_FEATURE_KEY = 'agent';

interface initialAgentState {
  agentDataFromFirebase: AgentFlowProgress[];
  userId: string;
}

export const initialAgentState: initialAgentState = {
  agentDataFromFirebase: [],
  userId: '',
};

export const agentSlice = createSlice({
  name: AGENT_FEATURE_KEY,
  initialState: initialAgentState,
  reducers: {
    updateAgentDataFromFirebase: (
      state,
      action: PayloadAction<AgentFlowProgress[]>
    ) => {
      state.agentDataFromFirebase = action.payload;
    },
    updateUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
  },
});

export const { updateAgentDataFromFirebase, updateUserId } = agentSlice.actions;

export const getAgentSliceState = (rootState: RootState): initialAgentState =>
  rootState[AGENT_FEATURE_KEY];

export const getAgentDataFromFirebase = createSelector(
  getAgentSliceState,
  (state) => state.agentDataFromFirebase
);

export const getUserId = createSelector(
  getAgentSliceState,
  (state) => state.userId
);
